import * as yup from "yup";

import { ERRORS_MESSAGE } from "@bms/constants";

export const validation = () => {
  return yup.object().shape({
    email: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    password: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
  });
};
